import { SparklineIntervalTimeUnitEnum } from 'generated/graphql'

export function getCustomTimeUnitInterval(days: number) {
  if (days > 364) {
    return 'quarter'
  }

  if (days > 30) {
    return 'month'
  }

  if (days > 14) {
    return 'week'
  }

  return 'day'
}

const TIME_UNIT_MAP: Record<string, SparklineIntervalTimeUnitEnum> = {
  day: SparklineIntervalTimeUnitEnum.Day,
  week: SparklineIntervalTimeUnitEnum.Week,
  month: SparklineIntervalTimeUnitEnum.Month,
  quarter: SparklineIntervalTimeUnitEnum.Quarter,
}

export const convertTimeUnit = (unit: string): SparklineIntervalTimeUnitEnum =>
  TIME_UNIT_MAP[unit] ?? SparklineIntervalTimeUnitEnum.Week
